import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { address } from '../../../../environments/environment';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class OrderService {
  private ROOT_URL = address.API_SERVER_ADDRESS;

  constructor(private http: HttpClient, private db: AngularFireDatabase) { }

  async getShippingCredit(sellerId) {
    return this.http.get(this.ROOT_URL + "/payment/fetchCurrentbalance?sellerId=" + sellerId).toPromise();
  }

  async checkServiceAvailibility(bodyData) {
    const uri = this.ROOT_URL + '/shipmentglobal/serviceavailibility';
    const obj = bodyData;
    return this.http.post(uri, obj).toPromise();
  }

  async getOrderService(para) {
    var seller_id = para["sellerId"]
    const uri = this.ROOT_URL + '/shipmentglobal/orders/all?seller_id=' + seller_id;
    return this.http.get(uri).toPromise();
  }

  async getPickupLocation(bodyData) {
    const uri = this.ROOT_URL + '/shipmentglobal/getnativepickuplocation?' + bodyData;
    return this.http.get(uri).toPromise();
  }


  async shipmentCreateOrder(bodyData) {
    const uri = this.ROOT_URL + '/shipmentglobal/createnativeorder';
    const obj = bodyData;
    return this.http.post(uri, obj).toPromise();
  }

  async cancelOrderService(channel_order_id) {
    const uri = this.ROOT_URL + '/shipmentglobal/cancelorder';
    let payload = {
      "channel_order_id": channel_order_id
    };
    return this.http.post(uri, payload).toPromise();
  }

  async getServiceProviders(channel_order_id = null, optionalUrl = null) {
    if (optionalUrl == null) {
      const uri = this.ROOT_URL + '/shipmentglobal/getserviceproviders?channel_order_id=' + channel_order_id;
      return this.http.get(uri).toPromise();
    }
    else {
      const uri = this.ROOT_URL + '/shipmentglobal/getserviceproviders?query=' + optionalUrl;
      return this.http.get(uri).toPromise();
    }

  }

  async generatePickup(bodyData) {
    const uri = this.ROOT_URL + '/shipmentglobal/generatepickup';
    console.log('Sending req', uri, bodyData);
    const obj = bodyData;
    return this.http.post(uri, obj).toPromise();
  }
  

  //////





  async get_fullRemmitanceUpdateBySellerId(seller_id) {
    const uri = this.ROOT_URL + '/shipment/remmitancestatus/' + seller_id;
    // const uri = "http://localhost:3333/api/shipment/remmitancestatus/"+seller_id;
    return this.http.get(uri).toPromise();
  }

  async get_fullStatementBySellerId(sellerID) {
    // const uri = this.ROOT_URL + '/shipment/shippingstatement/creditdebit?sellerID=' + sellerID;
    const uri = this.ROOT_URL + '/payment/fetchwallettrxcedetails/?sellerId=' + sellerID;
    return this.http.get(uri).toPromise();
  }

  async get_fullRemmitanceBySellerId(sellerID) {
    // const uri = this.ROOT_URL + '/shipment/remmitance/' + seller_id;
    const uri = this.ROOT_URL + '/payment/fetchremittancedetails/?sellerId=' + sellerID;
    return this.http.get(uri).toPromise();
  }

  async getWeightDiscrepencyBySeller(sellerID) {
    const uri = this.ROOT_URL + '/shipment/weightdiscrepency?sellerID=' + sellerID;
    return this.http.get(uri).toPromise();
  }

  // async sync_status(seller_id) {
  //   const uri = this.ROOT_URL + '/shipment/sync-status?seller_id=' + seller_id;
  //   return this.http.get(uri).toPromise();
  // }

  async getWeightDiscrepencyRTOBySeller(sellerID) {
    // console.log('sellerID=', sellerID);
    const uri = this.ROOT_URL + '/payment/weightdiscrepencyrto?sellerId=' + sellerID;
    return this.http.get(uri).toPromise();
  }

  async updateWeightDiscrepencyRTOPayment(sellerId, disputedRows) {
    // console.log('sellerID=', sellerID);
    let payload = {
      "disputedRows": disputedRows,
      "sellerId": sellerId
    };
    const uri = this.ROOT_URL + '/payment/weightdiscrepencyrtopayment';
    return this.http.post(uri, payload).toPromise();
    // return this.http.get(uri).toPromise();
  }

}